import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ChangePasswordInput from '@app/model/profile/input/ChangePasswordInput';
import FormButton from '@app/component/form/button/FormButton';
import useToaster from '@app/component/overlays/toaster/ToasterHook';
import { useTranslation } from '@app/component/translation/Translation';
import SectionHeader from '@app/component/static/SectionHeader';
import { useMutation } from '@tanstack/react-query';
import ProfileService from '@app/model/profile/service/ProfileService';
import FormInputPassword from '@app/component/form/input/text/FormInputPassword';


const ProfileChangePasswordFragment = React.memo(() => {

    const form = useForm<ChangePasswordInput>();
    const toaster = useToaster();
    const {t} = useTranslation();

    useEffect(() => {
        reset();
    }, []);

    const reset = () => {
        form.reset({
            oldPassword: '',
            newPassword: '',
            repeatNewPassword: ''
        })
    }

    const changePasswordMutation = useMutation({
        mutationFn: ProfileService.changePassword,
        onSuccess: () => {
            toaster.success('Profile Settings', "Password changed successfully!");
            reset()
        }, onError:(error:string) => {
            if (error === 'server.exception.profile.WRONG_OLD_PASSWORD') {
                form.setError("oldPassword", {message: t(error)})
            } else if (error === 'server.exception.profile.PASSWORD_DOES_NOT_VALIDATE') {
                form.setError("newPassword", {message: t(error)})
            } else if (error === 'server.exception.profile.PASSWORDS_DO_NOT_MATCH') {
                form.setError("newPassword", {message: t(error)})
                form.setError("repeatNewPassword", {message: t(error)})
            }
        }
    })

    const onSubmit = (input: ChangePasswordInput) => {
        changePasswordMutation.mutate(input)
    }

    return <>
        <div className="pt-6">
            <SectionHeader>Password</SectionHeader>

            <div>

                <div className="flex flex-col lg:flex-row">
                    <div className="flex-grow space-y-6">
                        <div>
                            <FormInputPassword name='oldPassword' label="Current Password" form={form}/>
                        </div>
                        <div>
                            <FormInputPassword name='newPassword' label="New Password"
                                           labelHint='Your new password must contain more than 8 characters'
                                           form={form}/>
                        </div>
                        <div>
                            <FormInputPassword name='repeatNewPassword' label="Repeat New Password" form={form}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Actions */}
        <div className="mt-4 flex justify-end gap-x-3 py-4">
            <FormButton state='white' onClick={reset}>Reset</FormButton>
            <FormButton state='primary' onClick={form.handleSubmit(onSubmit)}>Save</FormButton>
        </div>
    </>
})

export default ProfileChangePasswordFragment;